const getPerformance = () => window.performance.now();
export default getPerformance;
